import './editorMainStyles.scss';
import { useCallback, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import { descriptionEditorOptions } from '@widgets/shared/descriptionEditor/settings.ts';
import { useMobile } from '@shared/hooks/index.ts';

const handleFocus = ({
  // setIsMobileToolbarActive,
  // isMobile,
  quillRef,
}: {
  quillRef: ReactQuill | null;
  // setIsMobileToolbarActive: (isActive: boolean) => void;
  // isMobile: boolean;
}) => {
  if (quillRef) {
    // для мобильной кнопочки обработчик
    // if (isMobile) {
    //   const isQlSettingsActive = document?.getElementsByClassName('ql-active')[0] as HTMLElement;
    //   const isHasQlToolbar = document?.getElementsByClassName('ql-toolbar')[0] as HTMLElement;
    //   if (isHasQlToolbar.style.display === 'flex') {
    //     setIsMobileToolbarActive(true);
    //   } else {
    //     setIsMobileToolbarActive(Boolean(isQlSettingsActive));
    //   }
    // }

    const editingArea = quillRef?.getEditingArea();
    const imageResizeToolbar = editingArea?.getElementsByClassName('toolbar')[0] as HTMLElement;
    const secondGroupInToolBar = imageResizeToolbar?.getElementsByClassName('group')[1];
    if (secondGroupInToolBar) {
      const floatLeftButton = secondGroupInToolBar.children[0];
      const centerButton = secondGroupInToolBar.children[1];
      const floatRightButton = secondGroupInToolBar.children[2];
      if (floatLeftButton) {
        floatLeftButton.setAttribute('data-styles', 'float:left;margin-right:20px;');
      }
      if (centerButton) {
        centerButton.setAttribute(
          'data-styles',
          'display:block;margin-right:auto; margin-left:auto;'
        );
      }
      if (floatRightButton) {
        floatRightButton.setAttribute('data-styles', 'float:right;margin-left:20px;');
      }
    }

    // toolbar
    const toolbarClientReacts = imageResizeToolbar?.getClientRects();
    const editorAreaClientReacts = editingArea?.getClientRects();
    // console.log(toolbarClientReacts);
    // console.log('editorSizes:',editingArea.getClientRects());
    if (toolbarClientReacts && toolbarClientReacts[0].top < 155) {
      // console.log("top")

      imageResizeToolbar.style.top = 'unset';
      imageResizeToolbar.style.bottom = '-90px';
    }
    if (
      toolbarClientReacts &&
      editorAreaClientReacts &&
      toolbarClientReacts[0].right < editorAreaClientReacts[0]?.right
    ) {
      // console.log("right")

      // imageResizeToolbar.style.left = '53%';
      imageResizeToolbar.style.left = '128.5px';
    }
    // if (toolbarClientReacts[0].x > editorAreaClientReacts[0].x) {
    //   console.log("left")
    //   imageResizeToolbar.style.left = '-10vw';
    //   // imageResizeToolbar.style.right = '10vw';
    // }

    // console.log('toolbar:', imageResizeToolbar.getClientRects());
  }
};
type PT = {
  value: string;
  onChange: (v: string) => void;
  // setIsMobileToolbarActive: (val: boolean) => void;
  // isMobileToolbarVisible: boolean;
  // setIsMobileToolbarVisible: (val: boolean) => void;
};

export const DescriptionEditor = ({
  value,
  onChange,
  // setIsMobileToolbarActive,
  // setIsMobileToolbarVisible,
  // isMobileToolbarVisible,
}: PT) => {
  const quillRef = useRef<ReactQuill | null>(null);
  const { isMobile } = useMobile();

  const addHandler = useCallback(() => {
    handleFocus({
      quillRef: quillRef?.current,
      // setIsMobileToolbarActive,
      // isMobile,
    });
  }, [
    // isMobile,
    // setIsMobileToolbarActive,
    quillRef,
  ]);

  // const setIsMobileToolbarVisibleFalse = useCallback(
  //   () => setIsMobileToolbarVisible(false),
  //   [setIsMobileToolbarVisible]
  // );

  useEffect(() => {
    document.addEventListener('click', addHandler);
    return () => {
      document.removeEventListener('click', addHandler);
    };
  }, []);
  // вариант с кнопкой для открытия на мобилке
  // useEffect(() => {
  //   const toolbar = document.getElementsByClassName('ql-toolbar')[0] as HTMLElement;
  //   const container = document.getElementsByClassName('ql-container')[0] as HTMLElement;

  // if (toolbar) {
  // toolbar.style.display = isMobileToolbarVisible ? 'flex' : 'none';
  // if (!isMobile) {
  //   toolbar.style.display = 'flex';
  // }
  // }
  // if (container) {
  // container.addEventListener('click', setIsMobileToolbarVisibleFalse);
  // }

  // return () => {
  //   if (container) {
  // container.removeEventListener('click', setIsMobileToolbarVisibleFalse);
  // }
  // };
  // }, [isMobileToolbarVisible, setIsMobileToolbarVisibleFalse, isMobile]);

  useEffect(() => {
    if (isMobile) {
      const toolbar = document.getElementsByClassName('ql-toolbar')[0] as HTMLElement;
      if (!toolbar) return;
      const formats = toolbar.querySelectorAll('.ql-formats');
      if (formats.length >= 3) {
        const lastThree = Array.from(formats).slice(-3);
        const wrapper = document.createElement('div');
        wrapper.className = 'formatsWrapper';
        lastThree.forEach((el) => {
          wrapper.appendChild(el); // перемещает узлы внутрь обертки
        });

        toolbar.appendChild(wrapper);
      }
    }
  }, [isMobile]);

  // логика удаления resizeModule при удалении фотки
  useEffect(() => {
    const editor = quillRef.current?.getEditor();
    if (!editor) return;

    // Получим инстанс resize-модуля, если он есть
    const resizeModule = editor.getModule('resize') as any;

    const onTextChange = (delta: any) => {
      // Если операция удаления (delete) найдена
      if (delta.ops?.some((op: any) => op.delete)) {
        // 2) Спрячем тулбар вручную
        document.querySelectorAll('#editor-resizer').forEach((el) => el.remove());

        // 3) Если модуль умеет скрывать тулбар программно
        if (resizeModule && typeof resizeModule.hide === 'function') {
          resizeModule.hide();
        }
      }
    };

    editor.on('text-change', onTextChange);
    return () => {
      editor.off('text-change', onTextChange);
    };
  }, []);

  return (
    <ReactQuill
      ref={quillRef}
      className="editWrapper"
      modules={descriptionEditorOptions.modules}
      formats={descriptionEditorOptions.formats}
      onChange={(value) => {
        // console.log(value);
        onChange(value);
      }}
      value={value}
      theme="snow"
    />
  );
};
